module.exports = __webpack_public_path__ + "media/images/icon__profile@3x-25418c2ef5be7244c513d5854f6545dc.png";